import { z } from 'zod';

/** Moves the cards engine accepts. Must match game-core's `CardsMove`. */
export const cardsMoveSchemas = [
  z.object({ type: z.literal('higher') }),
  z.object({ type: z.literal('lower') }),
  z.object({ type: z.literal('peek') }),
  z.object({ type: z.literal('cash') }),
] as const;

const card = z.object({ rank: z.number().int().min(2).max(14), suit: z.enum(['♠', '♥', '♦', '♣']) });

export const cardsViewSchema = z.object({
  current: card,
  last: card.nullable(),
  /** The next card, only in the reply to a peek. */
  peeked: card.nullable(),
  pot: z.number().int(),
  stake: z.number().int(),
  streak: z.number().int(),
  maxStreak: z.number().int(),
  suspicion: z.number(),
  /** Pot multiplier for a right guess; 0 when impossible. */
  higher: z.number(),
  lower: z.number(),
  cardsLeft: z.number().int(),
  say: z.string(),
  over: z.enum(['cash', 'caught', 'lose']).nullable(),
});
export type CardsView = z.infer<typeof cardsViewSchema>;
